import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Sep 11 2018
 * @author LZe
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { DataUploadLayer } from '../../transportLayers/data-upload/DataUploadLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * Data upload store
 */

export var DataUploadStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(DataUploadStore, _BaseStore);

  function DataUploadStore() {
    var _this;

    _classCallCheck(this, DataUploadStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataUploadStore).apply(this, arguments));
    _this.name = StoreName.DataUpload;
    _this.dataUploadLayer = new DataUploadLayer();
    _this.list = new Map();

    _this.getAll = function () {
      return _this.dataUploadLayer.findAll().then(function (dataUploads) {
        runInAction(function () {
          dataUploads.forEach(function (dataUpload) {
            _this.list.set(dataUpload.id, dataUpload);
          });
        });
        return dataUploads;
      });
    };

    _this.getOne = function (itemId) {
      return _this.dataUploadLayer.findOne(itemId).then(function (dataUpload) {
        runInAction(function () {
          _this.list.set(dataUpload.id, dataUpload);
        });
        return dataUpload;
      });
    };

    return _this;
  }

  return DataUploadStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], DataUploadStore.prototype, "list", void 0);

__decorate([action, __metadata("design:type", Object)], DataUploadStore.prototype, "getAll", void 0);

__decorate([action, __metadata("design:type", Object)], DataUploadStore.prototype, "getOne", void 0);